import { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || '';

function CampaignForm({ onCreated, compact = false }) {
  const [campaignName, setCampaignName] = useState('');
  const [campaignFile, setCampaignFile] = useState(null);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCreateCampaign = async (e) => {
    e.preventDefault();
    if (!campaignName.trim() || !campaignFile) {
      setStatus('Campaign name and CSV file are required.');
      return;
    }

    setLoading(true);
    setStatus('Uploading leads...');

    const form = new FormData();
    form.append('name', campaignName.trim());
    form.append('file', campaignFile);

    const res = await fetch(`${API_BASE}/backend/campaign_create.php`, {
      method: 'POST',
      body: form,
    });
    const text = await res.text();
    let data = null;
    try {
      data = JSON.parse(text);
    } catch (err) {
      setLoading(false);
      setStatus(`Upload response is not JSON: ${text.slice(0, 200)}`);
      return;
    }
    setLoading(false);

    if (data.ok) {
      const extra = data.failed ? ` Failed ${data.failed}.` : '';
      const debug = data.db_error ? ` Error: ${data.db_error}` : '';
      setStatus(`Campaign created (#${data.campaign_id}). Inserted ${data.inserted} leads.${extra}${debug}`);
      setCampaignName('');
      setCampaignFile(null);
      if (onCreated) onCreated();
    } else {
      setStatus(data.error || 'Failed to create campaign.');
    }
  };

  return (
    <div className={compact ? 'panel compact' : 'panel'}>
      <h2>Create Campaign</h2>
      <p className="muted">Upload the CSV you generated and attach it to a campaign.</p>
      <form onSubmit={handleCreateCampaign} className="row form">
        <label>
          Campaign Name
          <input value={campaignName} onChange={(e) => setCampaignName(e.target.value)} placeholder="Sacramento Agencies" />
        </label>
        <label>
          CSV File
          <input type="file" accept=".csv" onChange={(e) => setCampaignFile(e.target.files[0])} />
        </label>
        <button className="primary" type="submit" disabled={loading}>Create Campaign</button>
      </form>
      {status && <div className="status">{status}</div>}
    </div>
  );
}

export default CampaignForm;
